import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useRevealOnScroll } from "../hooks/useRevealOnScroll";
import {
  Cpu,
  Code2,
  Gauge,
  Smartphone,
  Search,
  Layers,
  Wand2,
} from "lucide-react";

const ICONS = [Cpu, Code2, Gauge, Smartphone, Search, Layers, Wand2];

const WhyBE1 = () => {
  const { t } = useLang();
  const ref = useRevealOnScroll([t]);

  return (
    <section id="why" ref={ref} data-testid="why-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="radial-blob" style={{ width: 500, height: 500, background: "#00F0FF", bottom: "-10%", left: "-15%", opacity: 0.15 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal text-[11px] tracking-[0.3em] uppercase font-bold text-[#00F0FF] mb-4">
          {t.why.overline}
        </div>
        <h2 className="reveal font-heading font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight gradient-text max-w-3xl" data-testid="why-title">
          {t.why.title}
        </h2>
        <p className="reveal mt-5 max-w-2xl text-[#9BA1B0] text-base sm:text-lg font-body">{t.why.subtitle}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {t.why.items.map((item, i) => {
            const Icon = ICONS[i] || Cpu;
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="reveal glass rounded-2xl p-6 md:p-7 flex items-start gap-5 hover:border-[#00F0FF]/30 transition-all duration-500"
              >
                <div className="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#00F0FF]/15 to-[#0055FF]/15 border border-[#00F0FF]/20">
                  <Icon size={20} className="text-[#00F0FF]" strokeWidth={1.6} />
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#00F0FF]/70 mb-1">
                    0{i + 1}
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-white">{item.title}</h3>
                  <p className="mt-1.5 text-sm text-[#9BA1B0] font-body leading-relaxed">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyBE1;
